import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Components */
import { Input, Icon } from "../../components"

/* REST API */
import { save, create } from "../../api/Member"

/* Helpers */
import { utils } from "../../helpers"

/* Shared */
import { DAYS, ROLES } from "./shared"

/* Widgets */
import { toast, pickTime } from "../common"

Modal.setAppElement("#root")


/* The working week a new master starts with */
const DEFAULT_SCHEDULE = DAYS.map(day => ({ day: day.day, startworktime: "09:00", endworktime: "18:00", isDayOff: day.day === "sunday" ? 1 : 0, breakStart: "", breakEnd: "" }))

/* The two ways one shift is written down. The repeating week keeps the same hours every week and
   cannot express a 2/2 rotation at all, so the rotation stands beside it */
const MODES = {
    week: "По дням недели",
    cycle: "Цикл смен"
}

/* The empty form of a master */
const INITIAL = {
    memberID: 0,
    name: "",
    phone: "",
    email: "",
    role: "specialist",
    profession: "",
    salary: "",
    share: "",
    inSchedule: 1,
    accessPhone: 0,
    accessBooking: 0,
    accessSchedule: 0,
    /* Does he hear the bookings of the point in Whatsapp. Told by default: a point which misses
       a booking loses a client. It is not a key of a specialist — the owner and the administrator
       hear the messages too, and it is exactly them a busy point wants to silence */
    notifyWhatsapp: 1,
    owner: false,
    worktimes: DEFAULT_SCHEDULE.map(day => ({ ...day })),
    /* The mode of the shift and the rotation behind it — the hours of a 2/2 shift are given
       from this card, the applications of the point have their own form for them */
    scheduleMode: "week",
    cycleOn: "2",
    cycleOff: "2",
    cycleFrom: "",
    cycleStartTime: "09:00",
    cycleEndTime: "21:00",
    cycleBreakStart: "",
    cycleBreakEnd: ""
}


/* Widget Member Modal — the card of one master: who he is, what he earns and by what schedule
   he works. It is opened by the reference: this._member.open(member, worktimes) */
class MemberModal extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            saving: false,
            ...INITIAL
        }
    }

    /* Open the card of the master — without him the form adds a new one */
    open = (member = null, worktimes = []) => {

        /* A new master of the point */
        if (!member) {
            this.setState({ visible: true, saving: false, ...INITIAL, worktimes: DEFAULT_SCHEDULE.map(day => ({ ...day })) })
            return
        }

        /* The schedule of this master, every day of the week in its own order */
        const schedule = DAYS.map(day => {

            const worktime = worktimes.find(item => item.day === day.day)

            if (!worktime) {
                return { day: day.day, startworktime: "09:00", endworktime: "18:00", isDayOff: 1, breakStart: "", breakEnd: "" }
            }

            return {
                day: day.day,
                startworktime: utils.check(worktime.startworktime, "09:00"),
                endworktime: utils.check(worktime.endworktime, "18:00"),
                isDayOff: parseInt(worktime.isDayOff) ? 1 : 0,
                breakStart: worktime.breakStart ? `${worktime.breakStart}`.slice(0, 5) : "",
                breakEnd: worktime.breakEnd ? `${worktime.breakEnd}`.slice(0, 5) : ""
            }
        })

        /* The day the rotation starts at — a master who has none yet starts it today */
        const today = new Date()
        const stamp = `${today.getFullYear()}-${`${today.getMonth() + 1}`.padStart(2, "0")}-${`${today.getDate()}`.padStart(2, "0")}`

        this.setState({
            visible: true,
            saving: false,
            memberID: parseInt(member.memberID),
            name: utils.check(member.name, ""),
            phone: utils.check(member.phone, ""),
            email: utils.check(member.email, ""),
            role: utils.check(member.role, "specialist"),
            profession: utils.check(member.profession, ""),
            salary: member.salary ? `${member.salary}` : "",
            share: member.share ? `${member.share}` : "",
            inSchedule: parseInt(member.inSchedule) === 0 ? 0 : 1,
            accessPhone: parseInt(member.accessPhone) ? 1 : 0,
            accessBooking: parseInt(member.accessBooking) ? 1 : 0,
            accessSchedule: parseInt(member.accessSchedule) ? 1 : 0,
            /* A row of the team nobody has touched comes with 1 — the team was told all along */
            notifyWhatsapp: parseInt(member.notifyWhatsapp) === 0 ? 0 : 1,
            owner: member.role === "owner",
            worktimes: schedule,
            scheduleMode: `${member.scheduleMode}` === "cycle" ? "cycle" : "week",
            cycleOn: parseInt(member.cycleOn) > 0 ? `${parseInt(member.cycleOn)}` : "2",
            cycleOff: parseInt(member.cycleOff) >= 0 && member.cycleOff !== null ? `${parseInt(member.cycleOff)}` : "2",
            cycleFrom: member.cycleFrom ? `${member.cycleFrom}`.slice(0, 10) : stamp,
            cycleStartTime: member.cycleStartTime ? `${member.cycleStartTime}`.slice(0, 5) : "09:00",
            cycleEndTime: member.cycleEndTime ? `${member.cycleEndTime}`.slice(0, 5) : "21:00",
            cycleBreakStart: member.cycleBreakStart ? `${member.cycleBreakStart}`.slice(0, 5) : "",
            cycleBreakEnd: member.cycleBreakEnd ? `${member.cycleBreakEnd}`.slice(0, 5) : ""
        })
    }

    /* Close the card */
    close = () => {

        /* The request is already on its way */
        if (this.state.saving) {
            return
        }

        this.setState({ visible: false })
    }

    /* Choose the hour of one day — the window of the panel and not the one of the browser */
    time = (day, key, value, text) => {

        pickTime({ title: text, value }).then(chosen => {

            /* Nothing was chosen */
            if (!chosen) {
                return
            }

            this.setDay(day, key, chosen)
        })
    }

    /* Change one day of the schedule */
    setDay = (day, key, value) => {

        const { worktimes } = this.state
        const index = worktimes.findIndex(item => item.day === day)

        if (index === -1) {
            return
        }

        worktimes[index] = { ...worktimes[index], [key]: value }
        this.setState({ worktimes })
    }

    /* The same hours for every working day — the schedule is rarely different */
    everyDay = () => {

        const { worktimes } = this.state
        const first = worktimes.find(item => parseInt(item.isDayOff) === 0)

        /* There is nothing to copy from */
        if (!first) {
            toast.error("Сначала укажите рабочий день")
            return
        }

        this.setState({ worktimes: worktimes.map(item => ({ ...item, startworktime: first.startworktime, endworktime: first.endworktime, breakStart: first.breakStart, breakEnd: first.breakEnd })) })
    }

    /* The lunch break of one day — a day without it is worked through */
    setBreak = (day, value) => {

        this.setDay(day, "breakStart", value ? "13:00" : "")
        this.setDay(day, "breakEnd", value ? "14:00" : "")
    }

    /* One field of the rotation */
    setCycle = (field, value) => this.setState({ [field]: value })

    /* The mode of the shift. The week and the rotation are two ways of writing one shift, so the
       one which is not chosen keeps its fields and the mode is switched back without losing them */
    setMode = mode => this.setState({ scheduleMode: mode })

    /* A day either has no break at all or has both of its hours, and the end of it stands after
       the beginning. Half a break would leave the shift as it was and nobody would learn why */
    breakValid = (start, end) => {

        /* Hours */
        const from = `${start ? start : ""}`.slice(0, 5)
        const to = `${end ? end : ""}`.slice(0, 5)

        /* A day without a break is worked through */
        if (from === "" && to === "") {
            return true
        }

        /* Check */
        if (from.length !== 5 || to.length !== 5) {
            return false
        }

        return to > from
    }

    /* The key to the schedule of the whole point. «Ведёт записи» carries it along — a master who
       moves the visits of the team must see the day he works in, so the chip stays lit and does
       not switch while that key is on */
    schedule = () => {

        const { accessBooking, accessSchedule } = this.state

        if (accessBooking) {
            return
        }

        this.setState({ accessSchedule: accessSchedule ? 0 : 1 })
    }

    /* Save the master */
    save = () => {

        /* Fields */
        const { memberID, name, phone, email, role, profession, salary, share, inSchedule, accessPhone, accessBooking, accessSchedule, notifyWhatsapp, worktimes, saving } = this.state
        const { scheduleMode, cycleOn, cycleOff, cycleFrom, cycleStartTime, cycleEndTime, cycleBreakStart, cycleBreakEnd } = this.state
        const { organizationID, onSaved } = this.props

        /* The request is already on its way */
        if (saving) {
            return
        }

        if (name.trim().length === 0) {
            this._name.error("Введите имя участника")
            return
        }

        if (phone.length !== 18) {
            this._phone.error("Введите телефон участника")
            return
        }

        if (email.length > 0 && /\S+@\S+\.\S+/.test(email) === false) {
            this._email.error("Неверный формат Email")
            return
        }

        /* The money of the team is not asked for — a master may work without an oklad and
           without a share of his own. Spaces inside a sum are simply thrown away */
        const cleanSalary = `${salary}`.replace(/\s/g, "")
        const cleanShare = `${share}`.replace(/\s/g, "")

        if (cleanSalary.length > 0 && !/^\d+$/.test(cleanSalary)) {
            this._salary.error("Оклад — только цифры")
            return
        }

        if (cleanShare.length > 0 && (!/^\d+$/.test(cleanShare) || parseInt(cleanShare) > 100)) {
            this._share.error("Доля от 0 до 100")
            return
        }

        /* The rotation needs every part of it, otherwise nobody can read the schedule */
        if (scheduleMode === "cycle") {

            const on = parseInt(cycleOn)
            const off = parseInt(cycleOff)

            if (isNaN(on) || on < 1 || on > 31) {
                toast.error("Укажите, сколько дней подряд мастер работает")
                return
            }

            if (isNaN(off) || off < 0 || off > 31) {
                toast.error("Укажите, сколько дней подряд мастер отдыхает")
                return
            }

            if (`${cycleFrom}`.length !== 10) {
                toast.error("Укажите день, с которого начинается цикл")
                return
            }

            if (`${cycleStartTime}`.length !== 5 || `${cycleEndTime}`.length !== 5) {
                toast.error("Укажите часы рабочего дня цикла")
                return
            }

            if (!this.breakValid(cycleBreakStart, cycleBreakEnd)) {
                toast.error("Укажите обе границы обеденного перерыва")
                return
            }
        }

        /* A day whose break is filled in by halves — the whole week is refused at once */
        const broken = scheduleMode === "cycle"
            ? null
            : worktimes.find(item => parseInt(item.isDayOff) === 0 && !this.breakValid(item.breakStart, item.breakEnd))

        if (broken) {
            toast.error("Проверьте обеденный перерыв в графике работы")
            return
        }

        this.setState({ saving: true })

        const body = {
            id: organizationID,
            memberID,
            name: name.trim(),
            phone,
            email,
            role,
            profession,
            salary: cleanSalary,
            share: cleanShare,
            inSchedule,
            accessPhone,
            accessBooking,
            accessSchedule,
            notifyWhatsapp,
            worktimes,
            scheduleMode
        }

        /* The rotation keeps its own hours and its own break, the week falls back to the seven
           rows of the schedule */
        if (scheduleMode === "cycle") {
            body.cycleOn = parseInt(cycleOn)
            body.cycleOff = parseInt(cycleOff)
            body.cycleFrom = cycleFrom
            body.cycleStartTime = cycleStartTime
            body.cycleEndTime = cycleEndTime
            body.cycleBreakStart = cycleBreakStart
            body.cycleBreakEnd = cycleBreakEnd
        }

        const request = memberID ? save(body) : create(body)

        request.then(response => {

            this.setState({ saving: false })

            if (response && response.status === 200) {
                this.setState({ visible: false })
                onSaved()
                toast.success(memberID ? "Участник сохранён" : "Участник добавлен")
                return
            }

            /* The phone is already working in this point */
            if (response && response.status === 409) {
                toast.error("Участник с таким телефоном уже в команде")
                return
            }

            toast.error("Не удалось сохранить участника")
        }).catch(() => {
            this.setState({ saving: false })
            toast.error("Не удалось сохранить участника")
        })
    }

    /* The rotation: how many days of work, how many of rest, the day it starts at and the hours
       of a working day of it. One shift stands for every day of the turn, so the break of it is
       one pair of hours as well */
    _cycle = () => {

        /* Fields */
        const { cycleOn, cycleOff, cycleFrom, cycleStartTime, cycleEndTime, cycleBreakStart, cycleBreakEnd } = this.state

        return (
            <div className="member-modal-cycle">

                <div className="organization-details-inputs">
                    <Input label="Работает дней подряд" value={cycleOn} onChange={event => this.setCycle("cycleOn", event.target.value.replace(/\D/g, ""))} />
                    <Input label="Отдыхает дней подряд" value={cycleOff} onChange={event => this.setCycle("cycleOff", event.target.value.replace(/\D/g, ""))} />
                </div>

                <div className="member-modal-cycle-row">

                    <div className="member-modal-cycle-field">
                        <div className="member-modal-cycle-label">Начало цикла</div>
                        <input className="member-modal-cycle-input" type="date" value={cycleFrom} onChange={event => this.setCycle("cycleFrom", event.target.value)} />
                    </div>

                    <div className="member-modal-cycle-field">
                        <div className="member-modal-cycle-label">Смена с</div>
                        <div onClick={() => pickTime({ title: "Смена — начало", value: cycleStartTime }).then(chosen => chosen && this.setCycle("cycleStartTime", chosen))} className="member-modal-time">
                            {cycleStartTime}
                        </div>
                    </div>

                    <div className="member-modal-cycle-field">
                        <div className="member-modal-cycle-label">Смена до</div>
                        <div onClick={() => pickTime({ title: "Смена — конец", value: cycleEndTime }).then(chosen => chosen && this.setCycle("cycleEndTime", chosen))} className="member-modal-time">
                            {cycleEndTime}
                        </div>
                    </div>
                </div>

                {/* The break of a working day of the turn — it is never asked for */}
                <div className="member-modal-cycle-row">

                    <div className="member-modal-cycle-field">
                        <div className="member-modal-cycle-label">Обед с</div>
                        <div onClick={() => pickTime({ title: "Обед — начало", value: cycleBreakStart ? cycleBreakStart : "13:00" }).then(chosen => chosen && this.setCycle("cycleBreakStart", chosen))} className="member-modal-time">
                            {cycleBreakStart ? cycleBreakStart : "—"}
                        </div>
                    </div>

                    <div className="member-modal-cycle-field">
                        <div className="member-modal-cycle-label">Обед до</div>
                        <div onClick={() => pickTime({ title: "Обед — конец", value: cycleBreakEnd ? cycleBreakEnd : "14:00" }).then(chosen => chosen && this.setCycle("cycleBreakEnd", chosen))} className="member-modal-time">
                            {cycleBreakEnd ? cycleBreakEnd : "—"}
                        </div>
                    </div>

                    <div className="member-modal-cycle-field">
                        <div className="member-modal-cycle-label">&nbsp;</div>
                        <div onClick={() => this.setState({ cycleBreakStart: "", cycleBreakEnd: "" })} className="member-modal-cycle-clear">Без обеда</div>
                    </div>
                </div>

            </div>
        )
    }

    /* The schedule of the master */
    _schedule = () => {

        /* Fields */
        const { worktimes } = this.state

        return (
            <div className="member-modal-schedule">
                {DAYS.map(day => {

                    const worktime = worktimes.find(item => item.day === day.day)

                    if (!worktime) {
                        return null
                    }

                    const off = parseInt(worktime.isDayOff) === 1

                    return (
                        <div key={day.day} className={`member-modal-day ${off ? "off" : ""}`}>

                            <div onClick={() => this.setDay(day.day, "isDayOff", off ? 0 : 1)} className="member-modal-day-text">
                                <i />
                                {day.text}
                            </div>

                            {off
                                ? <div className="member-modal-day-off">Выходной</div>
                                : <div className="member-modal-day-time">

                                    <div onClick={() => this.time(day.day, "startworktime", worktime.startworktime, `${day.text} — начало`)} className="member-modal-time">
                                        {worktime.startworktime}
                                    </div>

                                    <span>—</span>

                                    <div onClick={() => this.time(day.day, "endworktime", worktime.endworktime, `${day.text} — конец`)} className="member-modal-time">
                                        {worktime.endworktime}
                                    </div>

                                </div>
                            }

                            {!off && this._break(day, worktime)}

                        </div>
                    )
                })}
            </div>
        )
    }

    /* The lunch break of one working day. A day gets it by the button and gives it back by the
       cross, so a shift without a break holds no empty hours nobody filled in */
    _break = (day, worktime) => {

        /* The day is worked through */
        if (!worktime.breakStart && !worktime.breakEnd) {
            return (
                <div className="member-modal-day-break">
                    <div onClick={() => this.setBreak(day.day, true)} className="member-modal-break-add">Добавить обед</div>
                </div>
            )
        }

        /* The hours of the break */
        return (
            <div className="member-modal-day-break">

                <span className="member-modal-break-label">Обед</span>

                <div onClick={() => this.time(day.day, "breakStart", worktime.breakStart, `${day.text} — обед с`)} className="member-modal-time">
                    {worktime.breakStart}
                </div>

                <span>—</span>

                <div onClick={() => this.time(day.day, "breakEnd", worktime.breakEnd, `${day.text} — обед до`)} className="member-modal-time">
                    {worktime.breakEnd}
                </div>

                <div onClick={() => this.setBreak(day.day, false)} className="member-modal-break-clear" title="Убрать обед">
                    <Icon name="close" size={9} width={2.2} />
                </div>
            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible, memberID, name, phone, email, role, profession, salary, share, inSchedule, accessPhone, accessBooking, accessSchedule, notifyWhatsapp, owner, saving, scheduleMode } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={this.close}
                className="wide-modal"
                overlayClassName="wide-modal-overlay"
                closeTimeoutMS={200}
            >

                <div className="wide-modal-header">
                    <h2>{memberID ? "Редактировать участника" : "Новый участник"}</h2>
                    <div onClick={this.close} className="wide-modal-close">
                        <Icon name="close" size={11} width={2.2} />
                    </div>
                </div>

                <div className="wide-modal-body">

                    <div className="wide-modal-label">Кто это</div>

                    <div className="organization-details-inputs">
                        <Input ref={ref => this._name = ref} label="Имя" value={name} onChange={event => this.setState({ name: event.target.value })} />
                        <Input mask="+7 (999) 999-99-99" ref={ref => this._phone = ref} label="Телефон" value={phone} onChange={event => this.setState({ phone: event.target.value })} />
                    </div>

                    <div className="organization-details-inputs">
                        <Input ref={ref => this._email = ref} label="Email" value={email} onChange={event => this.setState({ email: event.target.value })} />
                        <Input ref={ref => this._profession = ref} label="Должность в команде" value={profession} onChange={event => this.setState({ profession: event.target.value })} />
                    </div>

                    <div className="wide-modal-label">Роль</div>
                    {owner
                        ? <div className="wide-modal-hint">Владельца точки нельзя перевести в другую роль — корона передаётся кнопкой «Сделать владельцем» у другого участника.</div>
                        : <div className="organization-details-chips">
                            {Object.keys(ROLES).filter(key => key !== "owner").map(key =>
                                <div
                                    key={key}
                                    onClick={() => this.setState({ role: key })}
                                    className={`organization-details-chip select ${role === key ? "active" : ""}`}
                                >
                                    {ROLES[key]}
                                </div>
                            )}
                        </div>
                    }

                    {role === "specialist" && !owner &&
                        <div className="organization-details-chips" style={{ marginTop: 10 }}>
                            <div onClick={() => this.setState({ accessPhone: accessPhone ? 0 : 1 })} className={`organization-details-chip select ${accessPhone ? "active" : ""}`}>Видит телефоны клиентов</div>
                            <div onClick={() => this.setState({ accessBooking: accessBooking ? 0 : 1 })} className={`organization-details-chip select ${accessBooking ? "active" : ""}`}>Ведёт записи</div>
                            <div onClick={this.schedule} className={`organization-details-chip select ${accessSchedule || accessBooking ? "active" : ""}`}>Видит расписание команды</div>
                        </div>
                    }

                    {/* The key to the schedule stands only here — the applications of the point
                        neither show it nor hand it out */}
                    {role === "specialist" && !owner &&
                        <div className="wide-modal-hint">
                            {accessBooking
                                ? "«Ведёт записи» уже открывает расписание всей команды: мастер видит записи коллег и меняет их. Выключите его, чтобы оставить специалисту только просмотр."
                                : "«Видит расписание команды» — специалист видит записи коллег, но ничего в них не меняет. Без него в календаре стоят только его собственные визиты. Доступ выдаётся только здесь — в Bookify Pro его нет."
                            }
                        </div>
                    }

                    <div className="wide-modal-label">Деньги</div>
                    <div className="wide-modal-hint">Оба поля можно оставить пустыми — мастер будет работать без оклада и без доли.</div>

                    <div className="organization-details-inputs">
                        <Input hint="Необязательно" ref={ref => this._salary = ref} label="Оклад в месяц, ₸" value={salary} onChange={event => this.setState({ salary: event.target.value })} />
                        <Input hint="Необязательно" ref={ref => this._share = ref} label="Доля с записей, %" value={share} onChange={event => this.setState({ share: event.target.value })} />
                    </div>

                    <div className="wide-modal-label">Уведомления в WhatsApp</div>
                    <div className="wide-modal-hint">По умолчанию мастер получает сообщения о новых записях, отменах и очереди. Выключите, если точка жалуется на поток сообщений — push в приложении при этом остаётся.</div>

                    <div className="organization-details-chips">
                        <div onClick={() => this.setState({ notifyWhatsapp: 1 })} className={`organization-details-chip select ${notifyWhatsapp ? "active" : ""}`}>Получает сообщения</div>
                        <div onClick={() => this.setState({ notifyWhatsapp: 0 })} className={`organization-details-chip select ${notifyWhatsapp ? "" : "active"}`}>Не получает</div>
                    </div>

                    <div className="wide-modal-label">Онлайн-запись</div>
                    <div className="organization-details-chips">
                        <div onClick={() => this.setState({ inSchedule: 1 })} className={`organization-details-chip select ${inSchedule ? "active" : ""}`}>Виден клиентам</div>
                        <div onClick={() => this.setState({ inSchedule: 0 })} className={`organization-details-chip select ${inSchedule ? "" : "active"}`}>Скрыт из расписания</div>
                    </div>

                    <div className="wide-modal-label">
                        График работы
                        {scheduleMode !== "cycle" && <span onClick={() => this.everyDay()}>Применить на все дни</span>}
                    </div>

                    {/* The repeating week keeps the same hours every week and cannot express a
                        2/2 rotation at all, so the rotation stands beside it */}
                    <div className="organization-details-chips">
                        {Object.keys(MODES).map(key =>
                            <div
                                key={key}
                                onClick={() => this.setMode(key)}
                                className={`organization-details-chip select ${scheduleMode === key ? "active" : ""}`}
                            >
                                {MODES[key]}
                            </div>
                        )}
                    </div>

                    <div className="wide-modal-hint">
                        {scheduleMode === "cycle"
                            ? "Цикл 2/2 и любой другой: мастер работает несколько дней подряд, потом столько же отдыхает. Часы смены и обед — одни на каждый рабочий день цикла."
                            : "Обычная неделя — по ней клиенты видят свободное время. Обед вырезается из смены: в эти часы записаться нельзя."
                        }
                    </div>

                    {scheduleMode === "cycle" ? this._cycle() : this._schedule()}

                    <div onClick={() => this.save()} className={`organization-details-button ${saving ? "disabled" : ""}`}>
                        {saving ? "Сохраняем..." : "Сохранить"}
                    </div>

                </div>

            </Modal>
        )
    }
}

export default MemberModal
